export default __webpack_public_path__ + "static/media/h100-8.fdf40bf2.png";